
import { memo } from "react";
import { IIconsProps } from "./icons.model";

const BarCodeChecked = (props: IIconsProps) => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <i
                id={props.id}
                className='fa-solid fa-barcode'
                style={{
                    fontSize: props.fontSize,
                    color: props.color,
                }} />
            <i
                id={props.id} className='fa-solid fa-check'
                style={{
                    fontSize: "12px",
                    color: "blue",
                    position: "absolute",
                }} />
        </div>
    );
};

export default memo(BarCodeChecked);

